import * as actions from './CurrentAssetAllocationChartActions';

const initialState = {};

const CashFlow = (state = initialState, action) => {
  switch (action.type) {
    case actions.RECEIVE_CURRENT_ASSET_ALLOCATION_DATA:
      return Object.assign({}, state, {
        [action.clientId]: {
          resp_data: action.data,
          is_initialized: true,
        },
      });

    default:
      return state;
  }
};

export default CashFlow;
